import React from 'react';
import styled from 'styled-components';
import { colors, fonts } from '../styles/globals';

const FooterContainer = styled.footer`
  background: linear-gradient(135deg, ${colors.primary} 0%, ${colors.darkBackground} 100%);
  color: ${colors.white};
  padding: 60px 20px 40px;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="1" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
    opacity: 0.1;
  }

  @media (max-width: 768px) {
    padding: 40px 20px 30px;
  }
`;

const FooterContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
`;

const FooterLogo = styled.div`
  font-family: ${fonts.playfair};
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 30px;
  background: linear-gradient(135deg, ${colors.white} 0%, ${colors.accent} 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const FooterLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 30px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 20px;
    flex-direction: column;
  }
`;

const FooterLink = styled.a`
  font-family: ${fonts.inter};
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
  padding: 8px 0;

  &:hover {
    color: ${colors.accent};
    transform: translateY(-1px);
  }
`;

const FooterDivider = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
  margin: 30px 0;
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: ${colors.white};
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 1.2rem;

  &:hover {
    background: ${colors.accent};
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(243, 156, 107, 0.3);
  }
`;

const Copyright = styled.p`
  font-family: ${fonts.inter};
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
`;

function Footer() {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterLogo>Eduardo Gaoch</FooterLogo>
        
        <FooterLinks>
          <FooterLink href="/politica-privacidad">Política de privacidad</FooterLink>
          <FooterLink href="/terminos-uso">Términos de uso</FooterLink>
        </FooterLinks>

        <FooterDivider />

        <SocialLinks>
          <SocialLink href="https://instagram.com/eduardogaoch" target="_blank" rel="noopener noreferrer">
            📱
          </SocialLink>
          <SocialLink href="https://wa.me/+1234567890" target="_blank" rel="noopener noreferrer">
            💬
          </SocialLink>
          <SocialLink href="mailto:hola@eduardogaoch.com">
            ✉️
          </SocialLink>
        </SocialLinks>

        <Copyright>
          © 2024 Eduardo Gaoch. Todos los derechos reservados.
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
}

export default Footer; 